
import { z } from 'zod';


export type EventInfoSchema = {
  Id:  string,
  Name: string,
  EventPath: string,
  DateFrom: Date,
  DateTo: Date,
  Live: boolean,
  error: string

}

const dateNullable = z.preprocess(
  v => (v === '' || v == null ? null : v),
  z.coerce.date().nullable()
);

export const dateRequired = z.preprocess(
  v => (v === '' || v == null ? undefined : v),   // make empty/null fail as "required"
  z.coerce.date({
    required_error: "Date is required",
    invalid_type_error: "Invalid date",
  })
);

// export const EventFeatureSchema = z.object({
//   EventId: z.string().optional().default(""),
//   Networking: z.boolean().optional().default(false),
//   WatchTogether: z.boolean().optional().default(false),
//   Workshops: z.boolean().optional().default(false),
//   Agenda: z.boolean().optional().default(false),
//   Plenum: z.boolean().optional().default(false),
//   HelpDesk_VideoChatroomId: z.boolean().optional().default(false),
//   DocumentCenter: z.boolean().optional().default(false),
//   ContactForm: z.boolean().optional().default(false),
//   Games: z.boolean().optional().default(false),
//   Marketplace: z.boolean().optional().default(false),
//   EventTracking: z.boolean().optional().default(false),
//   Showroom: z.boolean().optional().default(false),
//   WorldMap: z.boolean().optional().default(false),
// });

export const EventSchema = z.object({
  Id: z.string().uuid().optional().nullable(),
  Name: z.string(),
  Subtitle: z.string().optional(),
  Info: z.string().optional(),
  PWModerator: z.string().optional().default(""),
  PW: z.string().optional(),
  EventPath: z.string(),
  DateFrom: dateRequired,
  DateTo: dateRequired,
  Live: z.boolean(),
  Deleted: z.boolean(),
  DeleteAfter: z.number(),
  LanguageSwitch: z.boolean(),
  DefaultLanguage: z.string(),
  Languages: z.string().optional(),
  PrivacyType: z.number().optional(),
  PrivacyLink: z.string().optional(),
  CorporateInfoType: z.number().optional(),
  CorporateInfoLink: z.string().optional(),
  TermsOfUseLink: z.string().optional(),
  TermsOfUseType: z.number().optional(),
  LogoLink: z.string().optional(),
  Banner: z.string().nullish(),
  HideLogo: z.boolean().optional(),
  HideCountdown: z.boolean().optional(),
  SupportEmail: z.string().optional(),
  ContactEmail: z.string().optional(),
  TemplateId: z.number(),
  LobbyTypeId: z.number(),
  UserManagementTypeId: z.number(),
  AllowIncognito: z.boolean().optional().default(false),
  AllowNavigation: z.boolean().optional().default(true),
  UserManagementHideUserFields: z.boolean().optional().default(false),
  UserManagementHideExplicitLogin: z.boolean().optional().default(false),
  Domains: z.string().optional().default(""),
  AcceptPrivacyCheckbox: z.boolean().optional().default(false)
  
  
})
// export const UserManagementDPSSchema = z.object({
//  EventId: z.string(),
//  UMPTId: z.string(),
//   Selected: z.boolean().optional(),
//   Name: z.string().optional(),
//   DisplayText: z.string().optional(),
//   IsStrict: z.boolean().optional(),
//   ApiKey: z.string().optional()

// })


export type UserManagementDPS = {
  EventId:  string,
  Selected:boolean,
  UMPTId:  string,
  Name: string,
  DisplayName: string,
  IsStrict: boolean,
  ApiKey: string,
  RegistrationTypeID: number

}



export const EventFeature = z.object({
  EventId: z.string().optional().default(""),
  Networking: z.boolean().optional().default(false),
  WatchTogether: z.boolean().optional().default(false),
  Workshops: z.boolean().optional().default(false),
  Agenda: z.boolean().optional().default(false),
  TextChat: z.boolean().optional().default(false),
  Plenum: z.boolean().optional().default(false),
  HelpDesk_VideoChatroomId: z.boolean().optional().default(false),
  DocumentCenter: z.boolean().optional().default(false),
  ContactForm: z.boolean().optional().default(false),
  Games: z.boolean().optional().default(false),
  Marketplace: z.boolean().optional().default(false),
  EventTrackingFull: z.boolean().optional().default(false),
  EventTrackingPartial: z.boolean().optional().default(false),
  Showroom: z.boolean().optional().default(false),
  WorldMap: z.boolean().optional().default(false),
  UseCdn: z.boolean().optional().default(false)
});

export type EventFeatureModel = z.infer<typeof EventFeature>;

export function createDefaultEventFeature(eventId = ""): EventFeatureModel {
  return {
    EventId: eventId,
    Networking: false,
    WatchTogether: false,
    Workshops: false,
    Agenda: false,
    TextChat:false,
    Plenum: false,
    HelpDesk_VideoChatroomId: false,
    DocumentCenter: false,
    ContactForm: false,
    Games: false,
    Marketplace: false,
    EventTrackingFull: false,
    EventTrackingPartial: false,
    Showroom: false,
    WorldMap: false,
    UseCdn: false
  };
}


